var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "youtube-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "YouTube Ayarları - " + _vm.widget.title,
        width: "600px",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form, layout: "vertical" } },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.videoUrlOrId") } },
            [
              _c("a-input", {
                attrs: {
                  placeholder:
                    "https://www.youtube.com/watch?v=VIDEO_ID veya VIDEO_ID",
                },
                on: { change: _vm.handleVideoInputChange },
                model: {
                  value: _vm.videoInput,
                  callback: function ($$v) {
                    _vm.videoInput = $$v
                  },
                  expression: "videoInput",
                },
              }),
              _vm._v(" "),
              _vm.videoError
                ? _c("div", { staticClass: "error-message" }, [
                    _vm._v(_vm._s(_vm.videoError)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.playbackSettings") } },
            [
              _c(
                "div",
                { staticClass: "playback-settings" },
                [
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.autoplay,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "autoplay", $$v)
                        },
                        expression: "previewSettings.autoplay",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.autoplay")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.controls,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "controls", $$v)
                        },
                        expression: "previewSettings.controls",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.showControls")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showInfo,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "showInfo", $$v)
                        },
                        expression: "previewSettings.showInfo",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.showVideoInfo")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.loop,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "loop", $$v)
                        },
                        expression: "previewSettings.loop",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.loopPlay")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.mute,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "mute", $$v)
                        },
                        expression: "previewSettings.mute",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.startMuted")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.startTimeSeconds") } },
            [
              _c("a-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 0, max: 3600 },
                model: {
                  value: _vm.previewSettings.startAt,
                  callback: function ($$v) {
                    _vm.$set(_vm.previewSettings, "startAt", $$v)
                  },
                  expression: "previewSettings.startAt",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-form-item", { attrs: { label: _vm.$t("table.preview") } }, [
            _c("div", { staticClass: "preview-container" }, [
              _vm.previewSettings.videoId
                ? _c("iframe", {
                    staticStyle: { width: "100%", height: "315px" },
                    attrs: {
                      src: _vm.previewUrl,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "",
                    },
                  })
                : _c("div", { staticClass: "preview-placeholder" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("play_circle_outline"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("table.enterVideoUrlOrId"))),
                    ]),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: !_vm.previewSettings.videoId,
                  },
                  on: { click: _vm.handleSave },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("table.save")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }